import { useCallback } from "react"
import { useAxiosInstances } from "../../axios-instance"
import { IProcesso } from "../../../application/models"

export const useProcessoApi = () => {
    const { axiosAuthInstance } = useAxiosInstances()

    const createReprocessoApi = useCallback(async (data: {
        IdVelesGeoExtracao: number
    }): Promise<IProcesso> => {
        try {
            const result = await axiosAuthInstance.post('/geo-veles/processo/', {
                IdVelesGeoExtracao: data.IdVelesGeoExtracao
            })

            return result.data.processo
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const findProcessoByIdVelesGeoExtracaoApi = useCallback(async (data: {
        IdVelesGeoExtracao: number
    }): Promise<{
        processo: IProcesso
        arquivoExiste: boolean
    }> => {
        try {
            const result = await axiosAuthInstance.get(`/geo-veles/processo/extracao/${data.IdVelesGeoExtracao}`)

            return {
                processo: result.data.processo,
                arquivoExiste: result.data.arquivoExiste
            }
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const findProcessoByIdVelesGeoProcessoApi = useCallback(async(data: {
        IdVelesGeoProcesso: number
    }): Promise<IProcesso> => {
        try {
            const result = await axiosAuthInstance.get(`/geo-veles/processo/${data.IdVelesGeoProcesso}`)

            return result.data.processo
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    return {
        createReprocessoApi,
        findProcessoByIdVelesGeoExtracaoApi,
        findProcessoByIdVelesGeoProcessoApi
    }
}